import {
  NavigateButton,
  NotFound,
  PageContent,
  PageHeader,
} from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useCreateBreadcrumbs } from '@/hooks/creaet-breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { SnapshotsPage } from './_pages/SnapshotsPage';
import { SnapshotOrganizationsPage } from './detail/organizations/_pages/SnapshotOrganizationsPage';
import { SnapshotUsersPage } from './detail/users/_pages/SnapshotUsersPage';

export const SnapshotsRoutes = () => {
  const { t } = useTranslation();
  const { createBreadcrumb } = useCreateBreadcrumbs({ baseIndex: 3 });

  return (
    <Routes>
      <Route
        path="*"
        element={<NotFound showBackButton={false} height="100vh" />}
      />
      <Route
        index
        element={
          <>
            <PageHeader
              title={t('tenant-manager-root-page')}
              breadcrumbs={createBreadcrumb([
                { title: t('tenant-manager-root-page') },
              ])}
              buttons={
                <TenantManagerResourceGuard>
                  <NavigateButton
                    path="label"
                    text={t('hierarchy-labels-page')}
                  />
                </TenantManagerResourceGuard>
              }
            />
            <PageContent>
              <SnapshotsPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="/:id/organizations"
        element={<SnapshotOrganizationsPage />}
      />
      <Route path="/:id/users" element={<SnapshotUsersPage />} />
    </Routes>
  );
};
